export const ArmyTopIssueContainer = ({ MildHighCounts, heading }: any) => {
  return (
    <div
      style={{
        padding: "24px",
        background: "#fff",
        borderRadius: "18px",
        boxShadow: "0 4px 20px 0 rgba(166, 196, 205, 0.1)",
        maxWidth: 900,
        margin: "32px auto",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: 8,
        }}
      >
        <div
          style={{
            fontSize: "22px",
            fontWeight: 600,
            color: "black",
            letterSpacing: "1px",
          }}
        >
          {heading || "Top Issues"}
        </div>
      </div>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "0 28px",
          borderTop: "1px solid #eee",
        }}
      >
        {/* Left column */}
        <div>
          {MildHighCounts.slice(0, MildHighCounts.length === 13 ? 7 : 3).map(
            (item: any, idx: any) => (
              <div
                key={item.category}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "18px 0",
                  borderBottom: idx < 2 ? "1px solid #faf0e6" : "none",
                }}
              >
                <span
                  style={{
                    fontSize: "20px",
                    color: "#292929",
                  }}
                >
                  {item.category.replace(/_/g, " ")}
                </span>
                <span
                  style={{
                    fontSize: "22px",
                    color: "#ff8900",
                    fontWeight: 600,
                  }}
                >
                  {item.count}
                </span>
              </div>
            )
          )}
        </div>
        {/* Right column */}
        <div>
          {MildHighCounts.slice(
            MildHighCounts.length === 13 ? 7 : 3,
            MildHighCounts.length === 13 ? 13 : 6
          ).map((item: any, idx: any) => (
            <div
              key={item.category}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "18px 0",
                borderBottom: idx < 2 ? "1px solid #faf0e6" : "none",
              }}
            >
              <span
                style={{
                  fontSize: "20px",
                  color: "#292929",
                }}
              >
                {item.category.replace(/_/g, " ")}
              </span>
              <span
                style={{
                  fontSize: "22px",
                  color: "#ff8900",
                  fontWeight: 600,
                }}
              >
                {item.count}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
